"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.TeamsGraphAPIFailedSystemError = void 0;
const teamsfx_api_1 = require("@microsoft/teamsfx-api");
const localizeUtils_1 = require("../common/localizeUtils");
const types_1 = require("./types");
const common_1 = require("./common");
class TeamsGraphAPIFailedSystemError extends teamsfx_api_1.SystemError {
    constructor(e, correlationId, apiName, extraData) {
        const displayMessage = (0, common_1.matchDnsError)(e.message);
        const errorOptions = {
            source: "TeamsGraphClient",
            error: e,
            message: `Teams Graph API failed: [${e.name}] ${e.message} (api: ${apiName}, correlationId: ${correlationId}) ${extraData}`,
            displayMessage: displayMessage || (0, localizeUtils_1.getLocalizedString)("error.teamsGraph.apiFailed"),
            categories: [types_1.ErrorCategory.Unhandled, apiName],
        };
        super(errorOptions);
    }
}
exports.TeamsGraphAPIFailedSystemError = TeamsGraphAPIFailedSystemError;
//# sourceMappingURL=teamsGraph.js.map